import { ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { CustomTranslationService } from 'src/app/service/language/custom-translation.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-search-results-info',
  templateUrl: './search-results-info.component.html',
  styleUrls: ['./search-results-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SearchResultsInfoComponent implements OnInit, OnDestroy {
  @Input() count: number;
  searchBoxQuerySubscription$: Subscription;
  searchBoxQuery: string;

  isTablet = false;
  cxTabletWidth = this.breakpointService.getSize(BREAKPOINT.lg);

  activeCountry$: Observable<string> = this.countryService.getActive();
  activeLanguage$: Observable<string> = this.languageService.getActive();

  isCustomTranslationsEnabled$: Observable<boolean> = combineLatest([this.activeCountry$, this.activeLanguage$]).pipe(
    switchMap(([activeCountry, activeLanguage]) =>
      this.customTranslationService.isCustomTranslationsEnabled$(activeCountry, activeLanguage, [
        'customSearch.tabletCount',
      ])
    )
  );

  constructor(
    private breakpointService: BreakpointService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private componentService: ComponentService,
    private languageService: ShimanoLanguageService,
    private countryService: ShimanoCountryService,
    private customTranslationService: CustomTranslationService
  ) {}

  ngOnInit() {
    this.isTablet = window.innerWidth < this.cxTabletWidth;

    this.searchBoxQuerySubscription$ = this.route.params.subscribe((routeParams) => {
      this.searchBoxQuery = routeParams.query;
      this.cdr.detectChanges();
    });
  }

  get isGroupsetQuery(): boolean {
    const groupsetQuery = 'Groupset';
    const isGroupsetQuery = groupsetQuery.toLowerCase() === this.searchBoxQuery.toLowerCase();
    if (isGroupsetQuery) {
      this.componentService.setSearchBoxSuggestions(null);
    }
    return isGroupsetQuery;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isTablet = window.innerWidth < this.cxTabletWidth;
  }

  setCustomContext(isCustomTranslationsEnabled: boolean, activeCountry: string, activeLanguage: string) {
    return isCustomTranslationsEnabled ? [activeCountry, activeLanguage].join('-') : null;
  }

  ngOnDestroy() {
    if (this.searchBoxQuerySubscription$) {
      this.searchBoxQuerySubscription$.unsubscribe();
    }
  }
}
